import React from 'react';
import StepContentPanel from '../../../StepContentPanel';
import { createCleanMarkup } from '../../../../../../utils/common';
import { CmsContent, Room } from '../../../proctorStepsTypes';

interface GetStepDefinitionsProps {
  stepNum: number;
  cmsContent: CmsContent;
  stepDetails: Record<number, { heading: string; imgClass: string; imgDesc: string }>;
  room: Room;
  progressStepperMax: number;
}

const GetStepDefinitions: React.FC<GetStepDefinitionsProps> = ({
  stepNum,
  cmsContent,
  stepDetails,
  room,
  progressStepperMax,
}) => {
  const stepContent = cmsContent?.steps?.find((n) => n.step_number === stepNum);
  const mainPanelData = <div dangerouslySetInnerHTML={createCleanMarkup(stepContent?.main_panel_content)} />;
  const detailPanelData = <div dangerouslySetInnerHTML={createCleanMarkup(stepContent?.detail_panel_content)} />;

  const content = {
    main_panel_content: mainPanelData,
    main_panel_header: stepContent?.main_panel_header,
    detail_panel_content: detailPanelData,
    detail_panel_header: stepContent?.detail_panel_header,
  };

  const stepDetail = stepDetails[stepNum];

  return stepDetail ? (
    <StepContentPanel
      room={room}
      showProgressBar
      stepNum={stepNum}
      progressStepperMax={progressStepperMax}
      heading={stepDetail.heading}
      content={content}
      desc={content.main_panel_content}
      img={<div className={`${stepDetail.imgClass} step-illustration-img mt-4`} />}
      imgDesc={stepDetail.imgDesc}
    />
  ) : null;
};

export default GetStepDefinitions;
